import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import {handleLogout} from "../Utils/auth";
import moment from 'moment';
import { Link } from 'react-router-dom';

export class DetalhamentoCaixa extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      user: JSON.parse(this.props.user) ,
      saidas : 0,
      entradas: 0,
      comissao: 0,
      transacoes: []
    };
    this.listarTransacoes();
  }


  formatDate(data) {
  return moment(data).add(0,'days').format('DD-MM-YYYY')
  }
  listarTransacoes = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/por-user", {
        userId: this.state.user._id
      });
      this.setState({ transacoes: response.data });
      this.gerarSaldos();
    } catch (err) {
      console.log(err);
    }
  };

  gerarSaldos(){
    this.state.transacoes.map(item => {
      if(item.tipo == "Venda"){
        this.setState({comissao : this.state.comissao + item.taxaComissao})
        if(item.emissorId._id != this.state.user._id){
        this.setState({ entradas : this.state.entradas + item.valor});
      }
      else if(item.emissorId._id == this.state.user._id){
        this.setState({saidas : this.state.saidas + item.valor});
      }
    }
    })

    this.forceUpdate()
    
  }

  render() {
    return (
      <div class="content" >
      <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card strpied-tabled-with-hover">
              <div class="card-header ">
                <div class="row">
                  <div class="col">
                        <h4 class="card-title">{this.state.user.nome}</h4>
                  <p class="card-category">Informações do caixa.</p>
                  </div>
                </div>
              </div>
              <div class="card-body table-full-width table-responsive">
                  <div class="container">
                    <div class="row">
                    <div class="col font-weight-bold text-success">
                        Total em vendas: R${(this.state.entradas).toFixed(2)}
                    </div>
                    <div class="col font-weight-bold text-warning">
                        Valor a ser prestado: R${((this.state.entradas - this.state.saidas) -  this.state.comissao).toFixed(2)}
                    </div>
                    <div class="col font-weight-bold text-dark">
                         Comissão dele {this.state.user.comissao}%: R${this.state.comissao.toFixed(2)}
                    </div>

                    </div>
                  </div>
              </div>
            </div>
          </div>
      </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card strpied-tabled-with-hover">
              <div class="card-header ">
                <h4 class="card-title">Movimentações</h4>
                <p class="card-category">Informações de movimentações.</p>
              </div>
              <div class="card-body table-full-width table-responsive">
                <table class="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Tipo</th>
                      <th>Emissor</th>
                      <th>Receptor</th>
                      <th>Valor</th>
                      <th>Taxa de Comissão</th>
                      <th>Documento</th>
                      <th>Observação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.transacoes != null
                      ? this.state.transacoes.map((item) => {
                        
                          return (
                            
                            <tr
                              class=
                                "font-weight-bold "
                            >
                              <td>{this.formatDate(item.data)}</td>
                              <td>{item.tipo}</td>
                              {/* <td>{(item.emissorId._id == this.state.user._id
                                  ? "SAIDA"
                                  : "ENTRADA")}</td> */}
                              <td>{item.emissorId.nome}</td>
                              <td>{item.receptorId.nome}</td>
                              <td>
                                {(item.emissorId._id == this.state.user._id
                                  ? "-"
                                  : "+") + item.valor}
                              </td>
                              <td>{item.taxaComissao.toFixed(2)}</td>
                              <td>{item.documento}</td>
                              <td>{item.observacao}</td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default DetalhamentoCaixa;
